import { useEffect, useState } from "react"
import { motion, AnimatePresence, useMotionValue, useSpring } from "framer-motion"
import Reveal, { SectionLabel } from "./Reveal"
import ServiceModal from "./ServiceModal"
import { services, complementaryServices } from "./data"

const Servicos = () => {
  const [hovered, setHovered] = useState(null)
  const [selected, setSelected] = useState(null)
  const [canHover, setCanHover] = useState(false)

  const x = useSpring(useMotionValue(0), { stiffness: 250, damping: 30 })
  const y = useSpring(useMotionValue(0), { stiffness: 250, damping: 30 })

  useEffect(() => {
    const mq = window.matchMedia("(hover: hover) and (min-width: 960px)")
    const update = () => setCanHover(mq.matches)
    update()
    mq.addEventListener?.("change", update)
    return () => mq.removeEventListener?.("change", update)
  }, [])

  const onMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect()
    x.set(e.clientX - rect.left)
    y.set(e.clientY - rect.top)
  }

  return (
    <section className="k-section k-services" id="servicos">
      <div className="k-container">
        <div className="k-services__head">
          <Reveal>
            <SectionLabel index="02" light>
              Serviços
            </SectionLabel>
            <h2 className="k-h2">
              O que a gente <em>constrói</em> para você.
            </h2>
          </Reveal>
          <Reveal delay={0.1} as="p" className="k-services__intro">
            Soluções tecnológicas completas para transformar sua visão em realidade. Clique em um serviço para ver
            planos, valores e o que está incluso.
          </Reveal>
        </div>

        <div className="k-services__list" onMouseMove={onMove} onMouseLeave={() => setHovered(null)}>
          {services.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.08}>
              <button
                className={`k-service ${hovered !== null && hovered !== i ? "is-dim" : ""}`}
                onMouseEnter={() => setHovered(i)}
                onFocus={() => setHovered(i)}
                onClick={() => setSelected(s)}
              >
                <span className="k-service__num">0{i + 1}</span>
                <span className="k-service__main">
                  <span className="k-service__kicker">{s.kicker}</span>
                  <span className="k-service__title">{s.title}</span>
                  <span className="k-service__desc">{s.description}</span>
                  <span className="k-service__tags">
                    {s.features.map((f) => (
                      <span key={f}>{f}</span>
                    ))}
                  </span>
                </span>
                <span className="k-service__meta">
                  <span>
                    <small>a partir de</small>
                    {s.startingAt}
                  </span>
                  <span>
                    <small>prazo</small>
                    {s.deliveryTime}
                  </span>
                </span>
                <span className="k-service__go" aria-hidden>
                  ↗
                </span>
              </button>
            </Reveal>
          ))}

          <AnimatePresence>
            {canHover && hovered !== null && (
              <motion.div
                className="k-services__preview"
                style={{ x, y }}
                initial={{ opacity: 0, scale: 0.6, rotate: -8 }}
                animate={{ opacity: 1, scale: 1, rotate: -3 }}
                exit={{ opacity: 0, scale: 0.6, rotate: 4 }}
                transition={{ type: "spring", stiffness: 260, damping: 24 }}
              >
                <AnimatePresence mode="popLayout">
                  <motion.img
                    key={services[hovered].image}
                    src={services[hovered].image}
                    alt=""
                    initial={{ opacity: 0, scale: 1.15 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.35 }}
                  />
                </AnimatePresence>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        <div className="k-extras">
          <Reveal className="k-extras__head">
            <h3>Também fazemos</h3>
            <p>Serviços complementares para acelerar o crescimento da sua marca.</p>
          </Reveal>
          <div className="k-extras__grid">
            {complementaryServices.map((c, i) => (
              <Reveal key={c.name} delay={i * 0.06} className="k-extra">
                <span className="k-extra__plus" aria-hidden>
                  +
                </span>
                <h4>{c.name}</h4>
                <p>{c.description}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>

      <AnimatePresence>{selected && <ServiceModal service={selected} onClose={() => setSelected(null)} />}</AnimatePresence>
    </section>
  )
}

export default Servicos
